import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  paper: {
    padding: 2,
    paddingTop: 0,
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    height: "80vh",
    gap: 2,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
  },
  svgStyle: {
    width: "120px",
    height: "120px",
    fill: theme.palette.text.disabled,
  },
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  backIcon: {
    display: { xs: "flex", md: "none" },
    justifyContent: "flex-start",
  },
  headerContainer: {
    display: "flex",
    position: "sticky",
    top: 0,
    zIndex: 10,
    paddingTop: 2,
    paddingBottom: 1,
    background: theme.palette.background.paper,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    backgroundColor: theme.palette.color.stroke,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 60,
    height: 60,
    borderRadius: 2,
    mr: 2,
  },
  titleDescription: {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    maxWidth: { xs: "70vw", md: "30vw" },
  },
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    wordBreak: "break-word",
    maxWidth: { xs: "70vw", md: "30vw" },
  },
  saveButton: {
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    px: 2,
    py: 1,
    display: { xs: "none", md: "flex" },
    "&:hover": {
      backgroundColor: alpha(theme.palette.success.main, 0.2),
    },
    gap: 1,
  },
  saveButtonMobile: {
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    mt: 4,
    px: 2,
    py: 1,
    display: { xs: "flex", md: "none" },
    "&:hover": {
      backgroundColor: alpha(theme.palette.success.main, 0.2),
    },
    gap: 1,
  },
  textField: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 2,
    width: "100%",
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  boxTextAndIcon: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
});
